export class ItemPricingRecommendation {
  key: string = '';
  asin: string = '';
  sku: string = '';
  fnsku: string = '';
  description: string = '';
  createdAt: Date = new Date();
  imageUrl: string = '';
  salePrice?: number;
  minPrice: number = 0;
  maxPrice: number = 0;
  businessPrice: number = 0;
  inboundPrice: number = 0;
  recommendedQty: number = 0;
  trueRecommendedQty: number = 0;
  suggestPrice: number = 0;
  suggestedMin?: number;
  suggestedMax?: number;
  customPrice?: number;
  logCount: number = 0;
  status: string = 'NONE';
  onHand: number = 0;
  // onHandFbm: number = 0;
  // awdInventoryQty: number = 0;
  // inboundFcTransfer: number = 0;
  // inboundShipped: number = 0;
  // inboundReceiving: number = 0;
  // inboundShippedAwd: number = 0;
  // inboundReceivingAwd: number = 0;
  // inventorySourcePreference: string = '';
  // isUsingAwdInventoryQty: boolean = false;
  newBuyBox: number = 0;
  state: string = '';
  s2d: number = 0;
  s7d: number = 0;
  s14d: number = 0;
  s30d: number = 0;
  s60d: number = 0;
  s90d: number = 0;
  s180d: number = 0;
  s365d: number = 0;
  sMtd: number = 0;
  sYtd: number = 0;

  constructor(init?: Partial<ItemPricingRecommendation>) {
    if (init) {
      // if no values are passed in, fresh instantiation
      Object.assign(this, init);
    }
  }
}
